import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

const CarouselNextSkipButtons = (props) => {
  const [maxSlideToGo, setMaxSlideToGo] = useState(0);

  const {
    maxCardsOnPage,
    currentSlide,
    slideCount,
    goToSlide: caruselGoToSlide,
  } = props;

  useEffect(() => {
    const lastSlide = slideCount - maxCardsOnPage + 1;
    setMaxSlideToGo(lastSlide);
  }, [maxCardsOnPage]);

  const goToSlide = (index) => {
    if (index >= maxSlideToGo) {
      caruselGoToSlide(maxSlideToGo);
      return;
    }
    if (index < 0) {
      caruselGoToSlide(0);
      return;
    }
    caruselGoToSlide(index);
  };

  const skipVisibleItemsNext = () => {
    const slide = currentSlide + maxCardsOnPage - 1;
    goToSlide(slide);
  };

  const skipToLastSlide = () => {
    goToSlide(maxSlideToGo);
  };

  return (
    <>
      <ButtonWithIcon
        accessibility={{
          'aria-label': 'Skip next visible cards',
        }}
        isPrimary
        isIcon
        icon="skip_forward_arrow"
        onClick={skipVisibleItemsNext}
        disabled={currentSlide >= maxSlideToGo}
        data-test-id="next-skip-visible-carousel-button"
        className="mobile:hidden"
      />
      <ButtonWithIcon
        accessibility={{
          'aria-label': 'Skip to the last card',
        }}
        isPrimary
        isIcon
        icon="skip_to_end"
        onClick={skipToLastSlide}
        disabled={currentSlide >= maxSlideToGo}
        data-test-id="skip-to-end-carousel-button"
      />
    </>
  );
};

CarouselNextSkipButtons.propTypes = {
  maxCardsOnPage: PropTypes.number.isRequired,
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  goToSlide: PropTypes.func.isRequired,
};

export default CarouselNextSkipButtons;
